export const AC_COLORS = {
  domestic_equity: "#00e5ff",
  global_equity: "#818cf8",
  sovereign_debt: "#34d399",
  gold_commodity: "#f59e0b",
  crypto: "#a855f7",
  cash: "#64748b",
};

export const POS = "#00e676";
export const NEG = "#ff3b30";

export function ratingColor(rating) {
  switch (rating) {
    case "Strong Buy": return "#00e676";
    case "Accumulate":
    case "Accumulate on Dips": return "#00e5ff";
    case "Hold": return "#ffb300";
    case "Trim": return "#ff8f3b";
    default: return "#ff3b30";
  }
}

export function fmtMoney(valueInr, currency, usdInr = 83.5, opts = {}) {
  const { compact = false, decimals } = opts;
  const isUsd = currency === "USD";
  const v = isUsd ? valueInr / usdInr : valueInr;
  const sym = isUsd ? "$" : "₹";
  const abs = Math.abs(v);
  if (compact) {
    if (isUsd) {
      if (abs >= 1e9) return `${sym}${(v / 1e9).toFixed(2)}B`;
      if (abs >= 1e6) return `${sym}${(v / 1e6).toFixed(2)}M`;
      if (abs >= 1e3) return `${sym}${(v / 1e3).toFixed(1)}K`;
      return `${sym}${v.toFixed(0)}`;
    } else {
      if (abs >= 1e7) return `${sym}${(v / 1e7).toFixed(2)} Cr`;
      if (abs >= 1e5) return `${sym}${(v / 1e5).toFixed(2)} L`;
      if (abs >= 1e3) return `${sym}${(v / 1e3).toFixed(1)}K`;
      return `${sym}${v.toFixed(0)}`;
    }
  }
  const locale = isUsd ? "en-US" : "en-IN";
  const d = decimals ?? (abs < 100 && abs > 0 ? 2 : 0);
  return `${sym}${v.toLocaleString(locale, { minimumFractionDigits: d, maximumFractionDigits: d })}`;
}

export function fmtPct(v, digits = 2) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const s = v > 0 ? "+" : "";
  return `${s}${Number(v).toFixed(digits)}%`;
}

export function fmtNum(v, digits = 2) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return Number(v).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
